import { render, staticRenderFns } from "./detail_inquery.vue?vue&type=template&id=e73b8042&scoped=true"
import script from "./detail_inquery.vue?vue&type=script&lang=js"
export * from "./detail_inquery.vue?vue&type=script&lang=js"
import style0 from "./detail_inquery.vue?vue&type=style&index=0&id=e73b8042&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73b8042",
  null
  
)

export default component.exports